module.exports = __webpack_public_path__ + "img/Tablet - 26.cd71a19e.png";